(function () {
  'use strict';

  function initMobileCart() {
    var drawer = document.querySelector('cart-drawer');
    var cartLink = document.querySelector('[data-aib-mobile-nav-cart][data-cart-drawer="true"]');

    if (cartLink && drawer && typeof drawer.open === 'function') {
      cartLink.addEventListener('click', function (event) {
        event.preventDefault();
        drawer.open(cartLink);
      });
    }
  }

  function syncMobileCartBadge() {
    var mobileIcon = document.querySelector('.aib-mobile-bottom-nav__item--cart .aib-mobile-bottom-nav__icon');
    if (!mobileIcon) return;

    var sourceCount = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]');
    var count = sourceCount ? sourceCount.textContent.trim() : '';
    var badge = mobileIcon.querySelector('.aib-mobile-bottom-nav__badge');

    if (count) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'aib-mobile-bottom-nav__badge';
        badge.setAttribute('aria-hidden', 'true');
        mobileIcon.appendChild(badge);
      }
      badge.textContent = count;
    } else if (badge) {
      badge.remove();
    }
  }

  function initMobileCartBadge() {
    syncMobileCartBadge();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, syncMobileCartBadge);
    }

    var cartIcon = document.querySelector('#cart-icon-bubble');
    if (cartIcon && window.MutationObserver) {
      new MutationObserver(syncMobileCartBadge).observe(cartIcon, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }
  }

  function init() {
    initMobileCart();
    initMobileCartBadge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
